// Порог, выше которого голос уверенно отличается от шума комнаты.
const AUDIBLE = 0.08

interface MicLevelMeterProps {
  level: number
  micEnabled: boolean
}

// Ответ на вопрос «меня слышно?» до входа в звонок, а не после.
export function MicLevelMeter({ level, micEnabled }: MicLevelMeterProps) {
  const percent = Math.round(Math.min(1, Math.max(0, level)) * 100)
  const hint = !micEnabled
    ? 'Микрофон выключен'
    : level > AUDIBLE
      ? 'Вас слышно'
      : 'Скажите что-нибудь'
  return (
    <div className="flex items-center gap-3">
      {/* Полоска — визуальный дубль подписи: озвучивать бегущие проценты нечего,
          вердикт «вас слышно» рядом и живой. */}
      <div aria-hidden className="h-1.5 flex-1 overflow-hidden rounded-pill bg-bg-sunken">
        <div
          className="h-full rounded-pill bg-accent transition-[width] duration-75"
          style={{ width: `${percent}%` }}
        />
      </div>
      <span role="status" className="font-mono text-text-tertiary text-xs uppercase tracking-wide">
        {hint}
      </span>
    </div>
  )
}
